import {createI18n} from '@soopkr-fe/soop-i18n';
import '@soopkr-fe/soop-i18n/main';

const i18n = createI18n({
  namespaces: ['main'],
});

export const MainT = i18n.t;
export const MainI18n = i18n;
